/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import { Button, Tooltip } from '@material-ui/core';
import config from '../../../config';

const SoundPlayer = ({ filename, audioAttribution }) => {
  const [audio, setAudio] = useState(null);
  const [audioCount, setAudioCount] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const toggle = () => setIsPlaying(!isPlaying);

  useEffect(() => {
    if (audio) {
      if (isPlaying) {
        audio.play();
      } else {
        audio.pause();
      }
    }
  }, [isPlaying]);

  useEffect(() => {
    setAudio(new Audio(`${config.OBJECT_URL}/placementTest/audio/${filename}`));
    setIsPlaying(false);
    setAudioCount(0);
    if (audio) {
      audio.pause();
    }
    return () => {
      setIsPlaying(false);
      if (audio) {
        audio.removeEventListener('ended', () => setIsPlaying(false));
      }
    };
  }, [filename]);

  useEffect(() => {
    if (audio) {
      (audio.addEventListener('ended', () => {
        setIsPlaying(false);
        setIsPlaying(false);
        setAudioCount(audioCount + 1);
      }));
    }
    return () => {
      if (audio) {
        audio.removeEventListener('ended', () => setIsPlaying(false));
      }
    };
  }, [isPlaying, toggle]);

  return (
    <Tooltip title={audioAttribution}>
      <Button
        variant="contained"
        color="primary"
        onClick={toggle}
        disabled={audioCount === 2}
        startIcon={isPlaying ? <PauseCircleOutlineIcon /> : <PlayCircleOutlineIcon />}
      >
        {`${isPlaying ? 'Pause' : 'Play'} sound (${2 - audioCount})`}
      </Button>
    </Tooltip>
  );
};

SoundPlayer.defaultProps = {
  filename: '',
  audioAttribution: '',
};

SoundPlayer.propTypes = {
  filename: PropTypes.string,
  audioAttribution: PropTypes.string,
};

export default SoundPlayer;
